import React, { useState, useEffect, Fragment } from "react";
import Config from "../../Config";


import InputDate from "../../helpers/InputDate";
import InputText from "../../helpers/InputText";
import InputBankAccount from "../../helpers/InputBankAccount";
import InputCombo from "../../helpers/InputCombo";
import { tab } from "@testing-library/user-event/dist/tab";
import FormatDecimal from "../../helpers/FormatDecimal";


function InvoiceRaport(props)
{

    
    
    const [view, setView] = useState('btn');
 
    const [row, setRow] = useState( props.selected );
    const [isStarted, setIsStarted] = useState(0);
    const [isClosable, setIsCloseable] = useState(1);

 
 
    const startX = () => {

        
        props.mainView.showProgress();

        var req = {
            ids: props.selected,
            fak_kontrahenci_id: props.fak_kontrahenci_id,
        }



        fetch( Config.master + '/rest_v1_calc,invoice_pack', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                 

                    props.mainView.hideProgress();      
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "error" ,  (resp) => { closeDlg(); });  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "error" , (resp) => { closeDlg(); } );  
                    }else    
                    {
 
                        if(res.status == 'OK') //zatwierdzono prawidlowo.. mozna wystawiac kolejny..
                        {
                       
                            closeDlg();
                            props.mainView.showDialog( "Sukces",  "Zestawienie zostało wysłane." , "ok" , (resp) => { closeDlg(); } );  

                        }else
                        {
                            props.mainView.showDialog( "Błąd",  'Spróbuj ponownie za chwilę.' , "error" ,  (resp) => { closeDlg(); });    
                        }
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "error" ,  (resp) => { closeDlg(); } );
                   props.mainView.hideProgress();
         });
                   

         return false;

    }
    

 

    const showDlg = () => {
    
         setView("dlg");   
    }     

    const closeDlg = () => {
        setView("btn");  
        setIsStarted(0); 
   }  
 
   


    if(row == null)
    {
        setRow([]); 
        return <span>...</span>
    }


    var progress = null;
    var gotowych = 0;

    for(var k=0;k<row.length; k++)
        {
            if(row[k].status == 2) //oczekuje..
            {
                gotowych++;
            }
        }

    var proc =  parseInt( (100 * gotowych) / row.length);
    
    if(gotowych > 0) 
    {
        progress = <div><strong>Postęp {proc} % </strong></div>;
    }

    



    if(row.length != props.selected.length)
    {
        setRow(props.selected);
    }



    var dlg_view =  (

            <div className="dlg_window dlg_type_x shadowx">

                    <div className="dlg_title">
                        Zestawienie faktur
                    </div>


                    <div className="dlg_content_x">


                                   

                                  

                                    <br/>

                                    <div className="form_tab">

                                    <div>
                                        Zaznaczonych dokumentów: {row.length} 
                                    </div>

                                    {progress}
 
                                    <div className="bg_center scroll150 nostick">                                            

                                            <table className="table" >
                                                    <thead>
                                                    <tr className="header">                                                                                  
                                                        <td className="td_left">LP</td>                                                                                                                                
                                                        <td>Numer</td>                                                                                                                                                                                                                                                                                                                                                                                                                                        
                                                        <td>Data wyst.</td>                                                                                                                                                                                                                                                                                                                                                                                                                                        
                                                        <td>Do zapłaty</td>                                                                                                                                                                                                                                                                                                                                                                                                                                        
                                                        <td className="td_right">Status</td>                                                                                                                                                                                                                                                                                                                                                                                                                                        
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        row.map( (item, ix) => {

                                                            var st = item.status;
                                                            if(item.status == 0 || item.status == undefined ) st = "---";
                                                            if(item.status == 1) st = "Czekaj...";
                                                            if(item.status == 2) st = "Wydrukowano!";
                                                            if(item.status == 3) st = "Błąd!";

                                                            return <tr>
                                                                <td className="gocenter">{ix+1}</td>                                                                                                                                
                                                                <td className="gocenter">{item.numer_dokumentu}</td>                                                                                                                                                                                                                                        
                                                                <td className="gocenter">{item.data_wystawienia}</td>                                                                                                                                                                                                                                        
                                                                <td className="goright"> <FormatDecimal value={item.do_zaplaty} /> </td>                                                                                                                                                                                                                                        
                                                                <td className="gocenter" >{st}</td>  
                                                            </tr>
                                                        })

                                                    }
                                                </tbody>
                                            </table>

                                        </div>
  

                                        <div className="form_split"></div>
                                        <br/>
                                        <div className="form_split"></div>

                                        <div className="form_control">      
                                            {
                                                isStarted == 0 &&
                                                <Fragment>
                                                    
                                                     <div className="btn" onClick={startX}>wyślij zestawienie</div>                                                  
                                                </Fragment>                                                
                                            }                                                                                  
                                            &nbsp; &nbsp;
                                            {
                                                (isClosable == 1 || row.length == 0 ) &&
                                                <div className="btn" onClick={closeDlg}>zamknij</div>
                                            }  

                                                                                  
                                        </div>

                                       
                                        </div>

                    </div>

                
            </div>
    );

    if(view == 'btn') dlg_view = null;

    

    return  <React.Fragment>
                <div className="btn"    onClick={showDlg} >Wyślij (do mnie) zestawienie</div> 
                {dlg_view} 
           </React.Fragment>
}


export default InvoiceRaport;